/** @file matrixRows: writes a thin-instance matrix (three axis rows and a position) into a Float32Array. */

/** A mutable 3-vector (scratch for the frame loop). */
export type V3 = [number, number, number];

/** Babylon row-vector order at `o`: local x, y, z go to `x`, `y`, `z` (each row padded with 0), then `t` and 1. */
export function matrixRows(a: Float32Array, o: number, x: V3, y: V3, z: V3, t: V3): void {
  a[o] = x[0]; a[o + 1] = x[1]; a[o + 2] = x[2]; a[o + 3] = 0;
  a[o + 4] = y[0]; a[o + 5] = y[1]; a[o + 6] = y[2]; a[o + 7] = 0;
  a[o + 8] = z[0]; a[o + 9] = z[1]; a[o + 10] = z[2]; a[o + 11] = 0;
  a[o + 12] = t[0]; a[o + 13] = t[1]; a[o + 14] = t[2]; a[o + 15] = 1;
}
